export const CLASS_TYPE_PERSON = "people";
export const CLASS_TYPE_VEHICLE = "vehicle";
